<script>
    import Header from './parts/header.svelte';
    import SignModal from '../modals/sign.svelte';
    import ProfileModal from '../modals/profile.svelte';
    import CreditsModal from '../modals/credits.svelte';
    import SurveyModal from '../modals/survey.svelte';

    import modals from '../state/modals';
    import Footer from './parts/footer.svelte';

    export let page = null;

    // Listen for modal opening / closing // TODO: Do better
    $: setClipped($modals.profile_opened || $modals.sign_opened || $modals.event_opened || $modals.reservation_opened || $modals.credits_opened || $modals.survey_opened || $modals.order_opened)
    function setClipped(isClipped) {
        document.body.classList.toggle('is-clipped', isClipped);
    }
</script>

<style>
    #app {
        display: flex;
        flex-direction: column;
        height: 100%;
    }
</style>

<div id="app">
    <Header {page} />

    <slot />

    <Footer />

    <SignModal />
    <ProfileModal />
    <CreditsModal />
    <SurveyModal />
</div>
